import React, { Suspense } from 'react';
const LoadedAutocorrection = /*#__PURE__*/React.lazy(() => import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/extensible/async/autocorrection-component" */'./autocorrection-renderer').then(({
  LoadedAutocorrection
}) => ({
  default: LoadedAutocorrection
})));
export const AutocorrectAsyncWrapper = ({
  container,
  fallback
}) => {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(LoadedAutocorrection, {
    container: container,
    fallback: fallback
  }));
};